<icds-data-list-skeleton dataItemStyle="card">
	<ng-template icdsDataListItemTemplate>
		<div class="flex justify-between items-start p-4">
			<div class="flex flex-col gap-y-2">
				<p-skeleton height="1.2rem" width="18rem" />
				<div class="flex gap-x-4">
					<p-skeleton height="1rem" width="6rem" />
					<p-skeleton height="1rem" width="8rem" />
				</div>
				<div class="flex gap-x-4">
					<p-skeleton height="1rem" width="6rem" />
					<p-skeleton height="1rem" width="8rem" />
				</div>
				<div class="flex gap-x-4">
					<p-skeleton height="1rem" width="6rem" />
					<p-skeleton height="1rem" width="8rem" />
				</div>
			</div>
			<div>
				<p-skeleton height="1.5rem" width="4rem" />
			</div>
		</div>
	</ng-template>
</icds-data-list-skeleton>
